/**
 * بياناتٌ جغرافيّةٌ للفوترة: دولةٌ ← محافظة/منطقة ← مدينة.
 *
 * مصرُ كاملةٌ (السوقُ الأساسيّ) بمحافظاتها السبعِ والعشرين ومدنها، ثمّ دولُ
 * المنطقةِ بأقاليمها ومدنها الرئيسة. القوائمُ متتالية: اختيارُ الدولةِ يُرشّح
 * المحافظات، واختيارُ المحافظةِ يُرشّح المدن. البنيةُ قابلةٌ للتوسّع بإضافةِ
 * عناصرَ للمصفوفة.
 */
export interface GovNode {
  name: string;
  cities: string[];
}
export interface CountryNode {
  name: string;
  govLabel: string; // «المحافظة» في مصر، «المنطقة» في السعودية…
  govs: GovNode[];
}

export const COUNTRIES: CountryNode[] = [
  {
    name: 'مصر',
    govLabel: 'المحافظة',
    govs: [
      {
        name: 'القاهرة',
        cities: [
          'القاهرة',
          'مدينة نصر',
          'مصر الجديدة',
          'المعادي',
          'حلوان',
          'شبرا',
          'عين شمس',
          'المطرية',
          'الزيتون',
          'مدينة بدر',
          'القاهرة الجديدة (التجمّع)',
          'الشروق',
          'المرج',
          'حدائق القبة',
          'السيدة زينب',
          'مصر القديمة',
          'الوايلي',
        ],
      },
      {
        name: 'الجيزة',
        cities: [
          'الجيزة',
          'الدقي',
          'العجوزة',
          'المهندسين',
          'إمبابة',
          '6 أكتوبر',
          'الشيخ زايد',
          'الهرم',
          'فيصل',
          'البدرشين',
          'الصف',
          'أطفيح',
          'العياط',
          'الباويطي',
          'أوسيم',
          'كرداسة',
          'الحوامدية',
        ],
      },
      {
        name: 'الإسكندرية',
        cities: [
          'الإسكندرية',
          'محطة الرمل',
          'سيدي جابر',
          'سموحة',
          'ميامي',
          'المنتزه',
          'العجمي',
          'برج العرب',
          'العامرية',
          'أبو قير',
          'المعمورة',
          'المندرة',
        ],
      },
      {
        name: 'القليوبية',
        cities: ['بنها', 'شبرا الخيمة', 'القناطر الخيرية', 'قليوب', 'طوخ', 'كفر شكر', 'الخانكة', 'العبور', 'قها', 'الخصوص'],
      },
      {
        name: 'الدقهلية',
        cities: ['المنصورة', 'طلخا', 'ميت غمر', 'دكرنس', 'أجا', 'منية النصر', 'السنبلاوين', 'الجمالية', 'شربين', 'المطرية', 'بلقاس', 'ميت سلسيل', 'جمصة', 'محلة دمنة', 'نبروه'],
      },
      {
        name: 'الشرقية',
        cities: ['الزقازيق', 'العاشر من رمضان', 'منيا القمح', 'بلبيس', 'مشتول السوق', 'القنايات', 'أبو حماد', 'ههيا', 'أبو كبير', 'فاقوس', 'الصالحية الجديدة', 'الإبراهيمية', 'ديرب نجم', 'كفر صقر', 'أولاد صقر', 'الحسينية', 'صان الحجر', 'منشأة أبو عمر'],
      },
      {
        name: 'الغربية',
        cities: ['طنطا', 'المحلة الكبرى', 'كفر الزيات', 'زفتى', 'السنطة', 'قطور', 'بسيون', 'سمنود'],
      },
      {
        name: 'المنوفية',
        cities: ['شبين الكوم', 'مدينة السادات', 'منوف', 'سرس الليان', 'أشمون', 'الباجور', 'قويسنا', 'بركة السبع', 'تلا', 'الشهداء'],
      },
      {
        name: 'البحيرة',
        cities: ['دمنهور', 'كفر الدوار', 'رشيد', 'إدكو', 'أبو المطامير', 'أبو حمص', 'الدلنجات', 'المحمودية', 'الرحمانية', 'إيتاي البارود', 'حوش عيسى', 'شبراخيت', 'كوم حمادة', 'بدر', 'وادي النطرون', 'النوبارية الجديدة'],
      },
      {
        name: 'كفر الشيخ',
        cities: ['كفر الشيخ', 'دسوق', 'فوه', 'مطوبس', 'بلطيم', 'الحامول', 'بيلا', 'الرياض', 'سيدي سالم', 'قلين', 'سيدي غازي'],
      },
      {
        name: 'الفيوم',
        cities: ['الفيوم', 'الفيوم الجديدة', 'طامية', 'سنورس', 'إطسا', 'إبشواي', 'يوسف الصديق'],
      },
      {
        name: 'بني سويف',
        cities: ['بني سويف', 'بني سويف الجديدة', 'الواسطى', 'ناصر', 'إهناسيا', 'ببا', 'الفشن', 'سمسطا', 'الحلة'],
      },
      {
        name: 'المنيا',
        cities: ['المنيا', 'المنيا الجديدة', 'العدوة', 'مغاغة', 'بني مزار', 'مطاي', 'سمالوط', 'المدينة الفكرية', 'ملوي', 'دير مواس', 'أبو قرقاص'],
      },
      {
        name: 'أسيوط',
        cities: ['أسيوط', 'أسيوط الجديدة', 'ديروط', 'منفلوط', 'القوصية', 'أبنوب', 'أبو تيج', 'الغنايم', 'ساحل سليم', 'البداري', 'صدفا'],
      },
      {
        name: 'سوهاج',
        cities: ['سوهاج', 'سوهاج الجديدة', 'أخميم', 'أخميم الجديدة', 'البلينا', 'المراغة', 'المنشأة', 'دار السلام', 'جرجا', 'جهينة الغربية', 'ساقلته', 'طما', 'طهطا', 'الكوثر'],
      },
      {
        name: 'قنا',
        cities: ['قنا', 'قنا الجديدة', 'أبو تشت', 'نجع حمادي', 'دشنا', 'الوقف', 'قفط', 'نقادة', 'فرشوط', 'قوص'],
      },
      {
        name: 'الأقصر',
        cities: ['الأقصر', 'الأقصر الجديدة', 'إسنا', 'أرمنت', 'الطود', 'الزينية', 'البياضية', 'القرنة', 'الحبيل'],
      },
      {
        name: 'أسوان',
        cities: ['أسوان', 'أسوان الجديدة', 'دراو', 'كوم أمبو', 'نصر النوبة', 'كلابشة', 'إدفو', 'الرديسية', 'البصيلية', 'السباعية', 'أبو سمبل السياحية'],
      },
      {
        name: 'البحر الأحمر',
        cities: ['الغردقة', 'رأس غارب', 'سفاجا', 'القصير', 'مرسى علم', 'الشلاتين', 'حلايب', 'الدهار'],
      },
      {
        name: 'الوادي الجديد',
        cities: ['الخارجة', 'الداخلة', 'الفرافرة', 'باريس', 'موط'],
      },
      {
        name: 'مطروح',
        cities: ['مرسى مطروح', 'الحمام', 'العلمين', 'الضبعة', 'النجيلة', 'سيدي براني', 'السلوم', 'سيوة', 'مارينا', 'العلمين الجديدة'],
      },
      {
        name: 'شمال سيناء',
        cities: ['العريش', 'الشيخ زويد', 'رفح', 'بئر العبد', 'الحسنة', 'نخل'],
      },
      {
        name: 'جنوب سيناء',
        cities: ['الطور', 'شرم الشيخ', 'دهب', 'نويبع', 'طابا', 'سانت كاترين', 'أبو رديس', 'أبو زنيمة', 'رأس سدر'],
      },
      {
        name: 'بورسعيد',
        cities: ['بورسعيد', 'بورفؤاد', 'العرب', 'الزهور', 'الضواحي', 'المناخ', 'الجنوب'],
      },
      {
        name: 'الإسماعيلية',
        cities: ['الإسماعيلية', 'فايد', 'القنطرة شرق', 'القنطرة غرب', 'التل الكبير', 'أبو صوير', 'القصاصين الجديدة', 'نفيشة'],
      },
      {
        name: 'السويس',
        cities: ['السويس', 'الأربعين', 'عتاقة', 'الجناين', 'فيصل'],
      },
      {
        name: 'دمياط',
        cities: ['دمياط', 'دمياط الجديدة', 'رأس البر', 'فارسكور', 'الزرقا', 'السرو', 'الروضة', 'كفر سعد', 'كفر البطيخ', 'ميت أبو غالب'],
      },
    ],
  },
  {
    name: 'السعودية',
    govLabel: 'المنطقة',
    govs: [
      { name: 'الرياض', cities: ['الرياض', 'الخرج', 'الدوادمي', 'المجمعة', 'الزلفي', 'وادي الدواسر', 'الأفلاج', 'حوطة بني تميم', 'عفيف', 'الدرعية'] },
      { name: 'مكة المكرمة', cities: ['مكة المكرمة', 'جدة', 'الطائف', 'رابغ', 'القنفذة', 'الليث', 'خليص', 'الجموم', 'تربة', 'الكامل'] },
      { name: 'المدينة المنورة', cities: ['المدينة المنورة', 'ينبع', 'العلا', 'بدر', 'مهد الذهب', 'الحناكية', 'خيبر', 'العيص'] },
      { name: 'المنطقة الشرقية', cities: ['الدمام', 'الخبر', 'الظهران', 'الأحساء (الهفوف)', 'الجبيل', 'القطيف', 'حفر الباطن', 'الخفجي', 'رأس تنورة', 'بقيق', 'النعيرية'] },
      { name: 'القصيم', cities: ['بريدة', 'عنيزة', 'الرس', 'المذنب', 'البكيرية', 'البدائع', 'رياض الخبراء', 'عيون الجواء'] },
      { name: 'عسير', cities: ['أبها', 'خميس مشيط', 'بيشة', 'النماص', 'محايل عسير', 'تثليث', 'سراة عبيدة', 'ظهران الجنوب', 'رجال ألمع'] },
      { name: 'تبوك', cities: ['تبوك', 'الوجه', 'ضباء', 'تيماء', 'أملج', 'حقل', 'البدع'] },
      { name: 'حائل', cities: ['حائل', 'بقعاء', 'الغزالة', 'الشنان', 'موقق', 'السليمي'] },
      { name: 'الحدود الشمالية', cities: ['عرعر', 'رفحاء', 'طريف', 'العويقيلة'] },
      { name: 'جازان', cities: ['جازان', 'صبيا', 'أبو عريش', 'صامطة', 'بيش', 'الدرب', 'فرسان', 'الطوال'] },
      { name: 'نجران', cities: ['نجران', 'شرورة', 'حبونا', 'بدر الجنوب', 'يدمة', 'ثار'] },
      { name: 'الباحة', cities: ['الباحة', 'بلجرشي', 'المندق', 'المخواة', 'قلوة', 'العقيق', 'القرى'] },
      { name: 'الجوف', cities: ['سكاكا', 'دومة الجندل', 'القريات', 'طبرجل'] },
    ],
  },
  {
    name: 'الإمارات',
    govLabel: 'الإمارة',
    govs: [
      { name: 'أبوظبي', cities: ['أبوظبي', 'العين', 'الرويس', 'مدينة زايد', 'ليوا', 'الظفرة'] },
      { name: 'دبي', cities: ['دبي', 'حتا', 'جبل علي', 'ديرة', 'بر دبي'] },
      { name: 'الشارقة', cities: ['الشارقة', 'خورفكان', 'كلباء', 'دبا الحصن', 'الذيد', 'مليحة'] },
      { name: 'عجمان', cities: ['عجمان', 'مصفوت', 'المنامة'] },
      { name: 'أم القيوين', cities: ['أم القيوين', 'فلج المعلا'] },
      { name: 'رأس الخيمة', cities: ['رأس الخيمة', 'الرمس', 'الجزيرة الحمراء', 'خت', 'مسافي'] },
      { name: 'الفجيرة', cities: ['الفجيرة', 'دبا الفجيرة', 'مربح', 'قدفع', 'البدية'] },
    ],
  },
  {
    name: 'الكويت',
    govLabel: 'المحافظة',
    govs: [
      { name: 'العاصمة', cities: ['مدينة الكويت', 'الشرق', 'المرقاب', 'القبلة', 'الدسمة', 'الشامية'] },
      { name: 'حولي', cities: ['حولي', 'السالمية', 'الجابرية', 'بيان', 'مشرف', 'سلوى'] },
      { name: 'الفروانية', cities: ['الفروانية', 'العارضية', 'خيطان', 'جليب الشيوخ', 'الرقعي'] },
      { name: 'مبارك الكبير', cities: ['مبارك الكبير', 'أبو الحصانية', 'العدان', 'القصور', 'صباح السالم'] },
      { name: 'الأحمدي', cities: ['الأحمدي', 'الفحيحيل', 'المهبولة', 'الفنطاس', 'المنقف', 'الوفرة'] },
      { name: 'الجهراء', cities: ['الجهراء', 'الصليبية', 'العبدلي', 'كبد', 'النعيم'] },
    ],
  },
  {
    name: 'قطر',
    govLabel: 'البلدية',
    govs: [
      { name: 'الدوحة', cities: ['الدوحة', 'الدفنة', 'الوعب', 'المنصورة'] },
      { name: 'الريان', cities: ['الريان', 'معيذر', 'الوجبة', 'اللؤلؤة'] },
      { name: 'الوكرة', cities: ['الوكرة', 'الوكير', 'مسيعيد'] },
      { name: 'الخور', cities: ['الخور', 'الذخيرة', 'رأس لفان'] },
      { name: 'الشمال', cities: ['مدينة الشمال', 'الرويس', 'أبو ظلوف'] },
      { name: 'أم صلال', cities: ['أم صلال محمد', 'أم صلال علي'] },
      { name: 'الشحانية', cities: ['الشحانية', 'دخان'] },
    ],
  },
  {
    name: 'البحرين',
    govLabel: 'المحافظة',
    govs: [
      { name: 'العاصمة', cities: ['المنامة', 'الجفير', 'العدلية', 'السنابس', 'الحورة'] },
      { name: 'المحرق', cities: ['المحرق', 'الحد', 'عراد', 'البسيتين', 'جزر أمواج'] },
      { name: 'الشمالية', cities: ['مدينة حمد', 'البديع', 'الجسرة', 'سار', 'باربار', 'الدراز'] },
      { name: 'الجنوبية', cities: ['الرفاع', 'مدينة عيسى', 'الزلاق', 'عوالي', 'جو'] },
    ],
  },
  {
    name: 'عُمان',
    govLabel: 'المحافظة',
    govs: [
      { name: 'مسقط', cities: ['مسقط', 'مطرح', 'بوشر', 'السيب', 'العامرات', 'قريات'] },
      { name: 'ظفار', cities: ['صلالة', 'مرباط', 'طاقة', 'ثمريت', 'رخيوت', 'ضلكوت'] },
      { name: 'الباطنة شمال', cities: ['صحار', 'شناص', 'لوى', 'صحم', 'الخابورة', 'السويق'] },
      { name: 'الباطنة جنوب', cities: ['الرستاق', 'العوابي', 'نخل', 'وادي المعاول', 'بركاء', 'المصنعة'] },
      { name: 'الداخلية', cities: ['نزوى', 'بهلاء', 'أدم', 'الحمراء', 'منح', 'إزكي', 'سمائل', 'بدبد'] },
      { name: 'الظاهرة', cities: ['عبري', 'ينقل', 'ضنك'] },
      { name: 'مسندم', cities: ['خصب', 'بخا', 'دبا', 'مدحاء'] },
      { name: 'البريمي', cities: ['البريمي', 'محضة', 'السنينة'] },
      { name: 'الشرقية شمال', cities: ['إبراء', 'المضيبي', 'بدية', 'القابل', 'وادي بني خالد', 'دماء والطائيين'] },
      { name: 'الشرقية جنوب', cities: ['صور', 'الكامل والوافي', 'جعلان بني بو علي', 'جعلان بني بو حسن', 'مصيرة'] },
      { name: 'الوسطى', cities: ['هيماء', 'محوت', 'الدقم', 'الجازر'] },
    ],
  },
  {
    name: 'الأردن',
    govLabel: 'المحافظة',
    govs: [
      { name: 'العاصمة (عمّان)', cities: ['عمّان', 'الجبيهة', 'ماركا', 'سحاب', 'وادي السير', 'أبو نصير'] },
      { name: 'إربد', cities: ['إربد', 'الرمثا', 'المزار الشمالي', 'بني كنانة', 'الكورة', 'الطيبة'] },
      { name: 'الزرقاء', cities: ['الزرقاء', 'الرصيفة', 'الأزرق', 'الضليل', 'الهاشمية'] },
      { name: 'البلقاء', cities: ['السلط', 'الفحيص', 'ماحص', 'دير علا', 'عين الباشا'] },
      { name: 'المفرق', cities: ['المفرق', 'الرويشد', 'صبحا', 'بلعما', 'الزعتري'] },
      { name: 'الكرك', cities: ['الكرك', 'المزار الجنوبي', 'القصر', 'عي', 'فقوع'] },
      { name: 'معان', cities: ['معان', 'البتراء (وادي موسى)', 'الشوبك', 'الحسينية'] },
      { name: 'العقبة', cities: ['العقبة', 'القويرة', 'الديسة', 'وادي رم'] },
      { name: 'مأدبا', cities: ['مأدبا', 'ذيبان', 'مليح'] },
      { name: 'جرش', cities: ['جرش', 'المصطبة', 'ساكب'] },
      { name: 'عجلون', cities: ['عجلون', 'كفرنجة', 'عنجرة'] },
      { name: 'الطفيلة', cities: ['الطفيلة', 'بصيرا', 'الحسا', 'العيص'] },
    ],
  },
  {
    name: 'لبنان',
    govLabel: 'المحافظة',
    govs: [
      { name: 'بيروت', cities: ['بيروت', 'الأشرفية', 'الحمرا', 'رأس بيروت'] },
      { name: 'جبل لبنان', cities: ['بعبدا', 'جونية', 'جبيل', 'المتن', 'عاليه', 'الشوف', 'كسروان'] },
      { name: 'الشمال', cities: ['طرابلس', 'زغرتا', 'بشري', 'الكورة', 'المنية', 'الضنية', 'البترون'] },
      { name: 'الجنوب', cities: ['صيدا', 'صور', 'جزين'] },
      { name: 'البقاع', cities: ['زحلة', 'بعلبك', 'رياق', 'شتورا'] },
      { name: 'النبطية', cities: ['النبطية', 'مرجعيون', 'بنت جبيل', 'حاصبيا'] },
      { name: 'عكار', cities: ['حلبا', 'القبيات', 'ببنين'] },
      { name: 'بعلبك الهرمل', cities: ['بعلبك', 'الهرمل', 'دير الأحمر'] },
    ],
  },
  {
    name: 'العراق',
    govLabel: 'المحافظة',
    govs: [
      { name: 'بغداد', cities: ['بغداد', 'الكاظمية', 'الأعظمية', 'المحمودية', 'أبو غريب', 'التاجي'] },
      { name: 'البصرة', cities: ['البصرة', 'الزبير', 'أبو الخصيب', 'القرنة', 'الفاو', 'شط العرب'] },
      { name: 'نينوى', cities: ['الموصل', 'تلعفر', 'سنجار', 'الحمدانية', 'الشيخان'] },
      { name: 'أربيل', cities: ['أربيل', 'شقلاوة', 'سوران', 'كويسنجق', 'مخمور'] },
      { name: 'النجف', cities: ['النجف', 'الكوفة', 'المشخاب', 'المناذرة'] },
      { name: 'كربلاء', cities: ['كربلاء', 'الهندية', 'عين التمر'] },
      { name: 'ذي قار', cities: ['الناصرية', 'الشطرة', 'الرفاعي', 'سوق الشيوخ', 'الجبايش'] },
      { name: 'الأنبار', cities: ['الرمادي', 'الفلوجة', 'هيت', 'حديثة', 'القائم', 'عانة'] },
      { name: 'السليمانية', cities: ['السليمانية', 'حلبجة', 'رانية', 'دوكان', 'جمجمال'] },
      { name: 'كركوك', cities: ['كركوك', 'الحويجة', 'داقوق', 'الدبس'] },
    ],
  },
  {
    name: 'المغرب',
    govLabel: 'الجهة',
    govs: [
      { name: 'الدار البيضاء سطات', cities: ['الدار البيضاء', 'سطات', 'المحمدية', 'برشيد', 'الجديدة', 'بنسليمان'] },
      { name: 'الرباط سلا القنيطرة', cities: ['الرباط', 'سلا', 'القنيطرة', 'تمارة', 'الخميسات', 'سيدي قاسم'] },
      { name: 'مراكش آسفي', cities: ['مراكش', 'آسفي', 'الصويرة', 'قلعة السراغنة', 'اليوسفية'] },
      { name: 'فاس مكناس', cities: ['فاس', 'مكناس', 'صفرو', 'تازة', 'إفران', 'الحاجب'] },
      { name: 'طنجة تطوان الحسيمة', cities: ['طنجة', 'تطوان', 'الحسيمة', 'العرائش', 'شفشاون', 'القصر الكبير'] },
      { name: 'سوس ماسة', cities: ['أكادير', 'إنزكان', 'تارودانت', 'تزنيت', 'أولاد تايمة'] },
      { name: 'الشرق', cities: ['وجدة', 'الناظور', 'بركان', 'تاوريرت', 'جرادة'] },
    ],
  },
  {
    name: 'تونس',
    govLabel: 'الولاية',
    govs: [
      { name: 'تونس', cities: ['تونس', 'حلق الوادي', 'المرسى', 'قرطاج', 'باردو'] },
      { name: 'صفاقس', cities: ['صفاقس', 'ساقية الزيت', 'طينة', 'المحرس', 'جبنيانة'] },
      { name: 'سوسة', cities: ['سوسة', 'مساكن', 'القلعة الكبرى', 'حمام سوسة', 'أكودة'] },
      { name: 'أريانة', cities: ['أريانة', 'رواد', 'سكرة', 'المنيهلة'] },
      { name: 'نابل', cities: ['نابل', 'الحمامات', 'قرمبالية', 'منزل تميم', 'قليبية'] },
      { name: 'بنزرت', cities: ['بنزرت', 'ماطر', 'منزل بورقيبة', 'رأس الجبل'] },
    ],
  },
  {
    name: 'الجزائر',
    govLabel: 'الولاية',
    govs: [
      { name: 'الجزائر', cities: ['الجزائر العاصمة', 'باب الزوار', 'الحراش', 'بئر مراد رايس', 'الدرارية'] },
      { name: 'وهران', cities: ['وهران', 'عين الترك', 'أرزيو', 'بطيوة', 'السانية'] },
      { name: 'قسنطينة', cities: ['قسنطينة', 'الخروب', 'حامة بوزيان', 'زيغود يوسف'] },
      { name: 'عنابة', cities: ['عنابة', 'البوني', 'سيدي عمار', 'الحجار'] },
      { name: 'سطيف', cities: ['سطيف', 'العلمة', 'عين ولمان', 'بوقاعة'] },
      { name: 'باتنة', cities: ['باتنة', 'بريكة', 'مروانة', 'عين التوتة', 'تازولت'] },
    ],
  },
  {
    name: 'ليبيا',
    govLabel: 'المنطقة',
    govs: [
      { name: 'طرابلس', cities: ['طرابلس', 'تاجوراء', 'جنزور', 'قصر بن غشير'] },
      { name: 'بنغازي', cities: ['بنغازي', 'قمينس', 'سلوق', 'توكرة'] },
      { name: 'مصراتة', cities: ['مصراتة', 'زليتن', 'الخمس', 'بني وليد'] },
      { name: 'الزاوية', cities: ['الزاوية', 'صرمان', 'العجيلات', 'صبراتة'] },
      { name: 'سبها', cities: ['سبها', 'أوباري', 'مرزق', 'براك الشاطئ'] },
      { name: 'الجبل الأخضر', cities: ['البيضاء', 'شحات', 'المرج', 'درنة'] },
    ],
  },
  {
    name: 'السودان',
    govLabel: 'الولاية',
    govs: [
      { name: 'الخرطوم', cities: ['الخرطوم', 'أم درمان', 'بحري (الخرطوم بحري)', 'شرق النيل', 'جبل أولياء'] },
      { name: 'الجزيرة', cities: ['ود مدني', 'الحصاحيصا', 'المناقل', 'الكاملين', 'رفاعة'] },
      { name: 'الشمالية', cities: ['دنقلا', 'مروي', 'الدبة', 'حلفا'] },
      { name: 'البحر الأحمر', cities: ['بورتسودان', 'سواكن', 'طوكر', 'سنكات'] },
      { name: 'كسلا', cities: ['كسلا', 'خشم القربة', 'حلفا الجديدة', 'أروما'] },
      { name: 'شمال دارفور', cities: ['الفاشر', 'كتم', 'كبكابية', 'مليط'] },
    ],
  },
  {
    name: 'فلسطين',
    govLabel: 'المحافظة',
    govs: [
      { name: 'القدس', cities: ['القدس', 'أبو ديس', 'العيزرية', 'بيت حنينا'] },
      { name: 'رام الله والبيرة', cities: ['رام الله', 'البيرة', 'بيتونيا', 'سلفيت'] },
      { name: 'نابلس', cities: ['نابلس', 'حوارة', 'بيتا', 'عصيرة الشمالية'] },
      { name: 'الخليل', cities: ['الخليل', 'دورا', 'يطا', 'حلحول', 'بيت أمر'] },
      { name: 'بيت لحم', cities: ['بيت لحم', 'بيت جالا', 'بيت ساحور', 'الدوحة'] },
      { name: 'غزة', cities: ['غزة', 'جباليا', 'بيت لاهيا', 'بيت حانون'] },
      { name: 'خان يونس', cities: ['خان يونس', 'بني سهيلا', 'عبسان'] },
      { name: 'جنين', cities: ['جنين', 'قباطية', 'يعبد', 'عرابة'] },
      { name: 'طولكرم', cities: ['طولكرم', 'عنبتا', 'بلعا'] },
      { name: 'رفح', cities: ['رفح', 'الشوكة', 'النصر'] },
    ],
  },
  {
    name: 'سوريا',
    govLabel: 'المحافظة',
    govs: [
      { name: 'دمشق', cities: ['دمشق', 'المزة', 'كفر سوسة', 'دوما', 'داريا', 'التل'] },
      { name: 'حلب', cities: ['حلب', 'الباب', 'منبج', 'عفرين', 'أعزاز', 'السفيرة'] },
      { name: 'حمص', cities: ['حمص', 'تدمر', 'الرستن', 'تلبيسة', 'القصير'] },
      { name: 'حماة', cities: ['حماة', 'سلمية', 'مصياف', 'محردة', 'السقيلبية'] },
      { name: 'اللاذقية', cities: ['اللاذقية', 'جبلة', 'القرداحة', 'الحفة'] },
      { name: 'طرطوس', cities: ['طرطوس', 'بانياس', 'صافيتا', 'الدريكيش'] },
      { name: 'درعا', cities: ['درعا', 'الصنمين', 'نوى', 'إزرع'] },
    ],
  },
  {
    name: 'اليمن',
    govLabel: 'المحافظة',
    govs: [
      { name: 'صنعاء', cities: ['صنعاء', 'بني مطر', 'همدان', 'أرحب'] },
      { name: 'عدن', cities: ['عدن', 'المعلا', 'خور مكسر', 'الشيخ عثمان', 'التواهي'] },
      { name: 'تعز', cities: ['تعز', 'التربة', 'المخا', 'صبر الموادم'] },
      { name: 'الحديدة', cities: ['الحديدة', 'باجل', 'زبيد', 'بيت الفقيه'] },
      { name: 'حضرموت', cities: ['المكلا', 'سيئون', 'تريم', 'الشحر', 'القطن'] },
      { name: 'إب', cities: ['إب', 'يريم', 'العدين', 'جبلة'] },
    ],
  },
];

/** أسماءُ الدول للقائمة الأولى. */
export const COUNTRY_NAMES = COUNTRIES.map((c) => c.name);

export function govsOf(country?: string): GovNode[] {
  return COUNTRIES.find((c) => c.name === country)?.govs ?? [];
}

export function citiesOf(country?: string, gov?: string): string[] {
  return govsOf(country).find((g) => g.name === gov)?.cities ?? [];
}

export function govLabelOf(country?: string): string {
  return COUNTRIES.find((c) => c.name === country)?.govLabel ?? 'المحافظة';
}
